/** @format */

import { useEffect, useState } from "react";
import { HiMenuAlt3 } from "react-icons/hi";
import { Link } from "react-router-dom";
import { WishCardMessage } from "../../utils/utils";

const HeaderMain = ({
  pathname,
  t,
  redirect_to_wishlist_page,
  redirect_to_card_page,
  wishList_count,
  card_total,
  showSliderbar,
  setShowSliderbar,
  redirect_to_chat_page,
  totalCustommerUnread,
}) => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 10);

    window.addEventListener("scroll", handleScroll, { passive: true });

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const navLinks = [
    { label: "Home", path: "/" },
    { label: "Shop", path: "/shops" },
    { label: "About", path: "/about" },
    { label: "Contact", path: "/contact" },
  ];

  return (
    <header
      className={`
        sticky top-0 left-0 w-full z-10
        transition-all duration-300
        ${
          scrolled
            ? "bg-white/90 backdrop-blur-md shadow-lg"
            : "bg-white border-b border-slate-100"
        }
      `}
    >
      <div className='w-[95%] lg:w-[90%] mx-auto'>
        <div className='h-[72px] flex items-center justify-between'>
          {/* ================= LOGO ================= */}
          <Link
            to='/'
            className='group flex items-center gap-2.5 py-1.5 px-3 rounded-md
                         bg-orange-500 hover:bg-orange-600
                         transition-all duration-200 ease-out
                         shadow-[0_2px_10px_rgba(249,115,22,0.35)]
                         hover:shadow-[0_4px_16px_rgba(249,115,22,0.45)]
                         hover:-translate-y-[1px]'
          >
            <img
              className='w-[36px] h-[36px] object-contain drop-shadow-sm'
              src='/images/logo.png'
              alt='Logo'
            />
            <span
              className='text-white text-lg font-extrabold tracking-widest
                              sm:block leading-none'
            >
              GOBYMALL
            </span>
          </Link>

          {/* ================= DESKTOP NAV ================= */}
          <nav className='md-lg:hidden flex items-center gap-2'>
            {navLinks.map(({ label, path }) => {
              const isActive = pathname === path;

              return (
                <Link
                  key={path}
                  to={path}
                  className={`
                    relative px-4 py-2 rounded-lg
                    text-[13px] font-semibold uppercase tracking-wider
                    transition-all duration-200
                    ${
                      isActive
                        ? "text-orange-500"
                        : "text-slate-600 hover:text-slate-900 hover:bg-slate-100"
                    }
                  `}
                >
                  {t(label)}

                  {isActive && (
                    <span
                      className='
                        absolute left-1/2 -translate-x-1/2
                        bottom-0
                        w-5 h-[3px]
                        rounded-full bg-orange-500
                      '
                    />
                  )}
                </Link>
              );
            })}
          </nav>

          {/* ================= ACTIONS ================= */}
          <div className='flex items-center gap-3'>
            {/* Desktop Icons */}
            <div className='md-lg:hidden flex items-center'>
              <WishCardMessage
                redirect_to_wishlist_page={redirect_to_wishlist_page}
                card_total={card_total}
                redirect_to_card_page={redirect_to_card_page}
                wishList_count={wishList_count}
                redirect_to_chat_page={redirect_to_chat_page}
                totalCustommerUnread={totalCustommerUnread}
              />
            </div>

            {/* Mobile Menu Button */}
            <button
              onClick={() => setShowSliderbar((prev) => !prev)}
              aria-label='Toggle menu'
              className='
                hidden
                w-10 h-10
                md-lg:flex items-center justify-center
                rounded-xl
                border border-slate-200
                bg-white
                text-slate-700
                hover:text-orange-500
                hover:border-orange-300
                transition-all duration-200
                shadow-sm
              '
            >
              <HiMenuAlt3 size={22} />
            </button>
          </div>
        </div>
      </div>
    </header>
  );
};

export default HeaderMain;
